import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AppConfig } from '../_helpers/appconfig.service';

@Injectable()
export class ExcelDateConvertService {
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  
  istimeZoneInteger = false;
  timeZoneOffset = 0;
  //timeZoneOffsetString;
  timeZoneValueArray = [];
  timeZoneDifferenceHours = 0;
  timeZoneDifferenceMinutes = 0;
  constructor() {
    this.init();
  }

  init(){

    //check the timezone
    var browserStorage;
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    //get client timezone hours and minutes
    this.timeZoneOffset = -(new Date().getTimezoneOffset() / 60);
    this.istimeZoneInteger = this.timeZoneOffset > 0 ? true : false;
    this.timeZoneValueArray = this.timeZoneOffset.toString().split('.')
    if (this.timeZoneValueArray.length == 2) {
      this.timeZoneDifferenceHours = Math.abs(this.timeZoneValueArray[0]);
      if (this.timeZoneValueArray[0] == '5') {
        this.timeZoneDifferenceMinutes = 30;
      } else if (this.timeZoneValueArray[0] == '75') {
        this.timeZoneDifferenceMinutes = 45;
      } else {
        this.timeZoneDifferenceMinutes = 0;
      }

    } else {
      this.timeZoneDifferenceHours = Math.abs(this.timeZoneValueArray[0]);
    }
  }
  
  convertExcelDateTime(date) {
    var dateTimeZoneDiff = date.split(/[- :]/),
    dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
    
    //convert the date to UTC-5 timezone
    dateFinal.setMilliseconds(this.offsetTimeVal);
    var dateObj = new Date(moment(dateFinal).format('MM/DD/YYYY HH:mm:ss'));
    
    //check daylight saving time
    var dst = moment(dateFinal).isDST();
    
    if (this.istimeZoneInteger == true) {
      if(dst == true){
        var newDate = new Date(dateObj.setHours(dateObj.getHours() + this.timeZoneDifferenceHours + 1));
        newDate = new Date(newDate.setMinutes(newDate.getMinutes() + this.timeZoneDifferenceMinutes));
      }else{
      var newDate = new Date(dateObj.setHours(dateObj.getHours() + this.timeZoneDifferenceHours));
      newDate = new Date(newDate.setMinutes(newDate.getMinutes() + this.timeZoneDifferenceMinutes));
      }
    } else {
      if (dst == true) {
        var newDate = new Date(dateObj.setHours(dateObj.getHours() - this.timeZoneDifferenceHours + 1));
        newDate = new Date(newDate.setMinutes(newDate.getMinutes() - this.timeZoneDifferenceMinutes));
      } else {
        var newDate = new Date(dateObj.setHours(dateObj.getHours() - this.timeZoneDifferenceHours));
        newDate = new Date(newDate.setMinutes(newDate.getMinutes() - this.timeZoneDifferenceMinutes));
      }
    }

    return newDate
  }

  convertExcelGMTTime(value) {
    var dateTimeZoneDiff = value.split(/[- :]/),
      dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
    dateFinal.setMilliseconds(Number(this.offsetTimeVal));
    var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
    var dateObj = new Date(dateString);
    var momentObj = moment(dateObj);
    var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
    return momentString;
  }
}
